import { IS_LOGGED_IN, IS_LOGGED_IN_FULFILLED, IS_LOGGED_IN_REJECTED } from '../actions'

export default (state = {
  data: null,
  fetching: false,
  fetched: false,
  error: null
}, action) => {
  switch (action.type) {
    case IS_LOGGED_IN:
      return { ...state, fetching: true, fetched: false, error: null }
    case IS_LOGGED_IN_FULFILLED:
      const payload = action.payload
      return { ...state, fetching: false, fetched: true, error: null, data: payload }
    case IS_LOGGED_IN_REJECTED:
      return { ...state, fetching: false, fetched: false, error: action.payload, data: null }

    default:
      return state
  }
}
